import React, { useMemo, useState, useEffect } from 'react'
import Dropdown from 'core/elements/dropdown'
import withProgress from 'core/components/progress/withProgress'
import { getPortsForVm } from 'openstack/components/networks/actions'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

export default function UsedFloatingIpsPicklist({
  disabled = false,
  name = 'fixedIp',
  label = 'Private IP',
  vmId,
  ...rest
}) {
  const [vmPorts, setVmPorts] = useState([])
  const [loadingVmPorts, setLoadingVmPorts] = useState(true)

  useEffect(() => {
    if (!vmId) {
      return
    }
    const getPorts = async () => {
      try {
        const response = await getPortsForVm({ vmId })
        setVmPorts(response)
      } catch (e) {
        console.log(e)
      } finally {
        setLoadingVmPorts(false)
      }
    }
    getPorts()
  }, [vmId])

  const options = useMemo(() => {
    return vmPorts.map((port) => {
      const ipAddressString = port.fixed_ips?.map((ip) => ip.ip_address)?.join(', ')
      return {
        label: ipAddressString,
        value: port.id,
      }
    })
  }, [vmPorts])

  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loadingVmPorts}
      items={options}
    />
  )
}
